import {Select} from '@primer/react'
import React from 'react'

const EVERYONE_VALUE = ' '

export interface Organization {
  globalRelayId?: string
  id?: string
}
export interface OrganizationOption {
  value: string
  label: string
  globalRelayId?: string
}

type OrganizationSelectProps = {
  organizationOptions: OrganizationOption[]
} & React.ComponentProps<typeof Select>

const OrganizationSelect = ({defaultValue, organizationOptions, ...rest}: OrganizationSelectProps) => {
  return (
    <Select
      block
      name="organization_id"
      defaultValue={defaultValue ?? EVERYONE_VALUE}
      data-testid="user-status-organization-select"
      {...rest}
    >
      <Select.Option value={EVERYONE_VALUE}>Everyone</Select.Option>
      {organizationOptions.map(({value, label}) => (
        <Select.Option key={value} value={value}>
          {label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default OrganizationSelect
OrganizationSelect.__SLOT__ = Select.__SLOT__

try{ OrganizationSelect.displayName ||= 'OrganizationSelect' } catch {}